import type { Settings } from "@/settings/types";
import { apiClient } from "./apiClient";

export const settingsGateway = {
  async getSettings(): Promise<Settings> {
    return await apiClient.get("/api/settings");
  },

  async updateSettings(settings: Settings): Promise<Settings> {
    return await apiClient.put("/api/settings", settings);
  },
};
